import { george, i18n, observer, pr, React, theme, ui } from "aaa";
import { ChoosePhoneResponsive } from "components/common/ChoosePhone";
import { ActionButton } from "components/common/georgeComponents";
import { InfoBox } from "components/common/InfoBox";
import { FormattedHTMLMessage } from "react-intl";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { ShowCardDataRoutes } from "./ShowCardDataRoutes";
import ShowCardDataStore from "./ShowCardDataStore";

type IProps = {
    store: ShowCardDataStore
};

export const ShowCardDataLandingPage = observer(({ store }: IProps) => {

    const handleClickSign = async () => {
        if (store.cardStore.card) {
            try {
                await store.getCardDataSignInfo();
                pushRoute(ShowCardDataRoutes.SIGNING);
            } catch (error) {
                pushRoute("/error");
            }
        }
    };

    const PageComponent = externalInterfaceStore.isGeorgeApp ? george.PageWithActionButton : React.Fragment;

    if (store.isLoading) {
        return <george.LoadingIndicator isLoading height={ui.windowHeight} />;
    }

    return (
        <george.Background>
            <PageComponent>
                <george.Card style={{ marginBottom: theme.MARGIN_SMALL }}>
                    <div style={{ padding: theme.MARGIN }}>
                        <pr.P_16_CONTENT>
                            {ui.__("showCardData.landing.text")}
                        </pr.P_16_CONTENT>
                        <div style={{ marginTop: theme.MARGIN_LARGE }}>
                            <george.ResponsiveSummaryElement label={ui.__("common.cardholder")} align="right">
                                <pr.P_16_CONTENT>{store.cardStore.card?.owner}</pr.P_16_CONTENT>
                            </george.ResponsiveSummaryElement>
                            <george.ResponsiveSummaryElement label={ui.__("common.cardNumber")} align="right">
                                <pr.P_16_CONTENT>{store.cardStore.card?.number}</pr.P_16_CONTENT>
                            </george.ResponsiveSummaryElement>
                            <george.ResponsiveSummaryElement label={ui.__("common.cardType")} align="right">
                                <pr.P_16_CONTENT>{store.cardStore.card?.productI18N}</pr.P_16_CONTENT>
                            </george.ResponsiveSummaryElement>
                        </div>
                        <InfoBox
                            style={{ margin: 0, width: "100%", marginTop: theme.MARGIN_LARGE }}
                            content={(
                                <pr.P_16_CONTENT>
                                    <FormattedHTMLMessage id={store.displayChannel === "SMS" ? "showCardData.landing.info.sms" : "showCardData.landing.info.oob"} />
                                </pr.P_16_CONTENT>
                            )}
                        />
                    </div>
                    {store.displayChannel === "SMS" &&
                        <>
                            <pr.LightSeparatorLine spacing={theme.MARGIN} />
                            <div style={{ padding: theme.MARGIN }}>
                                <ChoosePhoneResponsive
                                    contactsStore={store.contactsStore}
                                    onNewPhone={() => pushRoute(ShowCardDataRoutes.NEW_PHONE)}
                                    description={<i18n.FormattedHTMLMessage id="showCardData.landing.phone.info" />}
                                />
                            </div>
                        </>
                    }
                    <pr.LightSeparatorLine spacing={theme.MARGIN} />
                    <ActionButton
                        primary
                        messageId="button.continue"
                        onClick={handleClickSign}
                        disableButton={store.displayChannel === "SMS" && !store.contactsStore.selectedPhoneId}
                        {...george.getActionButtonWebVersionProps()}
                    />
                </george.Card>
            </PageComponent>
        </george.Background>
    );
});


// WEBPACK FOOTER //
// ./src/components/showCardData/ShowCardDataLandingPage.tsx